import { createI18nextInstance, useI18nextTranslation } from "@sg-protect/federation-runtime/i18n";
import type {
    FireflyRuntime,
    I18nextKey,
    I18nextTFunction,
    SquideModuleRegisterFunction
} from "@sg-protect/federation-runtime";
import { en } from "./en.ts";

declare module "@sg-protect/federation-runtime" {
    interface I18nextResources {
        components: typeof en;
    }
}

const componentsI18next = createI18nextInstance("components", en, {
    fr: async () => (await import("./fr.ts")).fr,
    de: async () => (await import("./de.ts")).de,
    es: async () => (await import("./es.ts")).es,
    nl: async () => (await import("./nl.ts")).nl
});

export const registerComponentsI18next: SquideModuleRegisterFunction<FireflyRuntime> = runtime => {
    componentsI18next.register(runtime);
};

export type ComponentsTFunction = I18nextTFunction<"components">;

export type ComponentsTranslationKey = I18nextKey<"components">;

export function useComponentsTranslation() {
    return useI18nextTranslation("components", componentsI18next.instance);
}
